module.exports = __webpack_public_path__ + "media/images/focus-wheel-intro-97c5b1322af27901d19e5d54ea51ac41.svg";